import { render, staticRenderFns } from "./check-gift.vue?vue&type=template&id=73fd3aad&scoped=true"
import script from "./check-gift.vue?vue&type=script&lang=js"
export * from "./check-gift.vue?vue&type=script&lang=js"
import style0 from "./check-gift.vue?vue&type=style&index=0&id=73fd3aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fd3aad",
  null
  
)

export default component.exports